const store = new Map();
export const readCache = (key) => store.get(key);
export const writeCache = (key, value) => { store.set(key, value); return value; };
export const cachedLoad = (key, fetcher, setter) => {
  const hit = store.get(key);
  if (hit !== undefined) setter(hit);
  return fetcher().then((v) => { store.set(key, v); setter(v); return v; });
};
export const clearCache = () => store.clear();
